import clsx from 'clsx';
import { useLocation, useNavigate } from 'react-router-dom';
import { formatViewObjectsPhrase } from '../../lib/utils';
import useLimitsSecondary from '../../api/hooks/use-limits-secondary';
import { BuyApartmentFlowPaths } from '../../routes';
import { MarketTypes } from '../../api/types';
import Menu from 'components/menu';
import IconButton from 'components/icon-button';
import Button from 'components/button';
import TabsSecondary from '../tabs-secondary';
import caretLeft from 'assets/images/caret-left.svg';
import styles from './styles.module.scss';
import { IPolygonItemRequest } from 'api/hooks/use-apartments-limits-secondary';

type BuySecondaryTabsProps = {
  selectedIds: number[];
  setSelectedIds: (ids: number[]) => void;
};
const BuySecondaryTabs = ({ selectedIds, setSelectedIds }: BuySecondaryTabsProps) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { count, isLoading, filterLimits } = useLimitsSecondary(true, MarketTypes.SECONDARY);

  const handleBack = () => navigate(-1);

  return (
    <main className={styles.container}>
      <header className={styles.header}>
        <div>
          <Menu />
          <IconButton icon={caretLeft} onClick={handleBack} />
        </div>
        <div className={styles.headerContainer}>
          <h1 className={styles.title}>Подбор объектов</h1>
          <div className={styles.description}>Вторичное жилье</div>
        </div>
        <div>{''}</div>
      </header>

      <section className={clsx(styles.content)}>
        <TabsSecondary
          tabsContainerClassName={styles.tabs}
          contentClassName={clsx(styles.paddedContent)}
          defaultTab={location.hash}
          selectedIds={selectedIds}
          setSelectedIds={setSelectedIds}
          polygons={(filterLimits?.polygons as IPolygonItemRequest[]) || []}
        />
      </section>

      <footer className={clsx(styles.buttons, styles.footer, styles.floatingSecondaryButtons)}>
        <Button
          label={isLoading ? 'Загрузка' : formatViewObjectsPhrase(count)}
          loading={isLoading}
          onClick={() => navigate(BuyApartmentFlowPaths.apartmentListBuySecondary)}
          disabled={isLoading || count === undefined}
          variant={'gray'}
          className={clsx(
            styles.viewApartmentsButton,
            count !== undefined && styles.viewApartmentButtonShow,
          )}
        />
        <Button
          label={'Подобрать квартиру вторички'}
          onClick={() => navigate(BuyApartmentFlowPaths.choosePriceRangeSecondary)}
          variant={'secondary'}
        />
      </footer>
    </main>
  );
};

export default BuySecondaryTabs;
